<template>
  <LibraryListItem>
    <div class="job-profile-col">
      <div class="text-h6 text-body-2 ellipsis-col">
        {{ flow.draft_profile?.title || '' }}
      </div>
      <div
        v-if="flow.draft_profile?.job_code"
        class="job-code text-body-3 ellipsis-col"
      >
        {{ flow.draft_profile.job_code }}
      </div>
    </div>

    <div class="status-col">
      <ApprovalStatusPill
        :status="flow.status"
        mode="overall"
      />
    </div>

    <div class="text-body-2 stages-col">
      {{ stagesLabel }}
    </div>

    <div class="text-body-2 created-by-col">
      {{ formatUserDisplayName(flow.created_by) }}
    </div>

    <div class="text-body-2 days-col">
      {{ flow.days ?? '' }}
    </div>

    <div class="actions-col" @click.stop>
      <DpplNewButton
        v-if="flow.status === 'pending'"
        variant="outlined"
        class="remind-btn"
        :loading="isReminding"
        @click="handleRemind"
      >
        <DpplSvg
          file-name="platform/notification"
          class="remind-icon mr-1"
        />
        Remind
      </DpplNewButton>
    </div>
  </LibraryListItem>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import ApprovalStatusPill from '@/components/jobProfiles/editor/ApprovalStatusPill.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { formatUserDisplayName } from '@/helpers/user';
import { useApprovalsDashboardStore } from '@/stores/jobProfiles/approvalsDashboard';
import { useTracking } from '@/stores/tracking/tracking';

const props = defineProps({
  flow: { type: Object, required: true },
});

const { remindFlowApprovers } = useApprovalsDashboardStore();
const { remindingFlowUlid } = storeToRefs(useApprovalsDashboardStore());

const stagesLabel = computed(() => {
  const current = props.flow?.current_stage;
  const total = props.flow?.stage_count;

  if (current == null || total == null) return '';

  return `${current} / ${total}`;
});

const isReminding = computed(() => remindingFlowUlid.value === props.flow?.ulid);

const handleRemind = () => {
  useTracking().approvalLibClickedRemind();

  remindFlowApprovers(props.flow);
};
</script>

<style lang="less" scoped>
.job-profile-col,
.status-col,
.stages-col,
.created-by-col,
.days-col {
  justify-self: start;
  padding-left: 16px;
}

.actions-col {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 16px;
}

.job-code {
  color: @text-light;
}

:deep(.remind-btn.v-btn) {
  padding: 5px 9px;
  border-radius: 5px;
  gap: 4px;
  color: @text-dark;
  background-color: @white;
}

:deep(.remind-btn.v-btn):not(.v-btn--disabled):hover {
  background-color: @bg-dark;
}

.remind-icon {
  width: 12px;
  height: 12px;
  color: @text-dark;
}
</style>
